export function applyEnvironmentFilter<T>(filter: Omit<T, 'environmentId'>, environmentId: string) {
  return {
    ...filter,
    environmentId: { eq: environmentId },
  };
}
